import { render, staticRenderFns } from "./Publicize.vue?vue&type=template&id=ed299520&"
import script from "./Publicize.vue?vue&type=script&lang=js&"
export * from "./Publicize.vue?vue&type=script&lang=js&"
import style0 from "./Publicize.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports